import React, {Component} from 'react';
import './ItemMintDescription.css';
import ShowMoreText from "react-show-more-text";

class ItemMintDescription extends Component {
  constructor(props) {
    super(props);
  }

  executeOnClick(isExpanded) {
    console.log(isExpanded);
  }


  render() {
    return (
      <div className = "videoMintDescription-MainContainer">
        <div className = "mt-4">
          <div className = "videoMintDescription-Header">
            DESCRIPTION
          </div>
          <div>
            <ShowMoreText
              className = "text-base flex dark:text-white text-black mt-2 flex-col w-80 sm:w-full"
              lines={5}
              more=<span className="dark:text-white text-black">Show more</span>
              less=<span className="dark:text-white text-black">Show less</span>
              onClick={this.executeOnClick}
              expanded={false}
              truncatedEndingComponent={"..."}
            >
            {this.props.item.description}
          </ShowMoreText>
          </div>
        </div>
      </div>
    );
  }
}

export default ItemMintDescription;
